export interface TranslationItem {
  name: string;
  code: string;
}

export enum TranslationCode {
  EN = 'en',
  SW = 'sw',
  ES = 'es',
  DE = 'de',
  SQ = 'sq',
}
